export const ContentaLogoV2 = () => (
  <svg
    width="170"
    height="22"
    viewBox="0 0 170 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M121.312 1.98157H117.752L119.807 5.50167H121.312H125.845L123.788 9.02612C123.852 9.02385 123.915 9.02177 123.979 9.02177C125.203 9.02177 126.317 9.51724 127.124 10.3168C127.93 11.1141 128.431 12.2141 128.431 13.4235V13.4243C128.431 15.8453 126.427 17.8267 123.979 17.8267H123.978C122.311 17.8267 120.85 16.9071 120.088 15.5563L120.034 15.4568L118.092 18.7831L118.189 18.8858C119.651 20.4002 121.709 21.3467 123.979 21.3467H123.979C128.385 21.3467 131.99 17.7817 131.99 13.4239V13.4235C131.99 10.9134 130.793 8.66643 128.936 7.21293L129.935 5.50167L131.99 1.98157H128.431H121.312ZM150.366 11.692C150.366 6.35266 154.784 1.98346 160.184 1.98346C161.967 1.98346 163.643 2.46002 165.088 3.29097L163.303 6.3485C162.384 5.82051 161.318 5.51755 160.184 5.51755C156.749 5.51755 153.94 8.29596 153.94 11.692C153.94 15.0882 156.749 17.8659 160.184 17.8659C161.318 17.8659 162.384 17.5633 163.303 17.0351L165.088 20.0929C163.643 20.9234 161.967 21.4 160.184 21.4C154.784 21.4 150.366 17.0315 150.366 11.692ZM142.711 1.98157H138.602L134.241 9.45767L134.239 9.46202C132.036 13.2357 133.356 18.1057 137.172 20.2844V20.2848C140.987 22.4637 145.912 21.1591 148.115 17.3854V17.3846C150.319 13.6109 148.999 8.74132 145.183 6.56201H145.183C143.758 5.74846 142.179 5.42092 140.645 5.52645L140.645 5.52436L142.711 1.98157ZM138.951 17.2358C141.072 18.4461 143.808 17.7214 145.032 15.6244C146.257 13.5273 145.523 10.8212 143.403 9.61123H143.403C141.283 8.40017 138.546 9.12484 137.322 11.2223H137.322C136.098 13.3193 136.831 16.0251 138.951 17.2358ZM12.0124 6.56876C10.8337 5.89136 9.46665 5.50255 8.0118 5.50255C3.60538 5.50255 0 9.06728 0 13.4249C0 17.7828 3.60538 21.3475 8.0118 21.3475C9.46665 21.3475 10.8349 20.9583 12.0144 20.281L10.2363 17.2348C9.58005 17.6113 8.81992 17.8272 8.0118 17.8272H8.01142C5.56296 17.8272 3.55986 15.8465 3.55986 13.4249C3.55986 11.0043 5.56296 9.02284 8.01142 9.02284H8.0118C8.81992 9.02284 9.57966 9.23919 10.2352 9.61571L12.0124 6.56876ZM102.219 5.50255H95.1H87.9816L90.0369 9.02284H93.3116V21.3475H96.8763V9.02284H100.164L102.219 5.50255ZM85.7598 13.4249H85.7546V21.3475H89.3198V13.4249C89.3198 9.06728 85.7146 5.50255 81.3076 5.50255C76.9014 5.50255 73.297 9.06728 73.297 13.4249V21.3475H76.8614V13.4249H76.8559C76.8559 11.0043 78.8595 9.02284 81.3076 9.02284C83.7561 9.02284 85.7598 11.0043 85.7598 13.4249ZM116.904 13.4236C116.904 9.0669 113.299 5.50142 108.893 5.50142C104.487 5.50142 100.882 9.0669 100.882 13.4236V13.424C100.882 17.7819 104.487 21.3468 108.893 21.3468C110.537 21.3468 112.07 20.8504 113.345 20.0015V21.3466H116.904V13.4244V13.424V13.4236ZM113.344 13.4236C113.344 11.0023 111.342 9.0219 108.893 9.0219C106.444 9.0219 104.441 11.0023 104.441 13.4236V13.4244C104.441 15.8454 106.444 17.8269 108.893 17.8269C111.342 17.8269 113.344 15.8454 113.344 13.4244V13.4236ZM72.1119 13.4236C72.1119 9.0669 68.5071 5.50142 64.1009 5.50142C59.6941 5.50142 56.0891 9.0669 56.0891 13.4236V13.424C56.0891 17.7819 59.6941 21.3468 64.1009 21.3468C65.5554 21.3468 66.924 20.9578 68.1033 20.2804L66.3245 17.2334C65.6692 17.6103 64.909 17.8269 64.1009 17.8269H64.1001C62.2842 17.8269 60.7143 16.7368 60.0234 15.1867H71.9102C72.0421 14.6188 72.1119 14.0293 72.1119 13.424V13.4236ZM64.1009 9.0219C65.9162 9.0219 67.4862 10.1108 68.1769 11.6613H60.0238C60.7145 10.1108 62.2854 9.0219 64.1001 9.0219H64.1009ZM57.4269 5.50255H50.3078H43.189L45.2437 9.02284H48.5188V21.3475H52.0844V9.02284H55.3716L57.4269 5.50255ZM40.9671 13.4249H40.9622V21.3475H44.527V13.4249C44.527 9.06728 40.922 5.50255 36.5154 5.50255C32.1093 5.50255 28.5044 9.06728 28.5044 13.4249V21.3475H32.0688V13.4249H32.0642C32.0642 11.0043 34.0669 9.02284 36.5152 9.02284H36.5154C38.964 9.02284 40.9671 11.0043 40.9671 13.4249ZM19.3069 5.50255H19.3066C14.9007 5.50255 11.2957 9.06728 11.2957 13.4249C11.2957 17.7828 14.9007 21.3475 19.3066 21.3475H19.3069C23.7138 21.3475 27.318 17.7828 27.318 13.4249C27.318 9.06728 23.7138 5.50255 19.3069 5.50255ZM19.3069 9.02284H19.3066C16.8585 9.02284 14.8556 11.0043 14.8556 13.4249C14.8556 15.8465 16.8585 17.8272 19.3066 17.8272H19.3069C21.7558 17.8272 23.7587 15.8465 23.7587 13.4249C23.7587 11.0043 21.7558 9.02284 19.3069 9.02284Z"
      fill="#002842"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M168.102 0H168.103C169.146 0 169.999 0.843999 169.999 1.87597V1.87635C169.999 2.90833 169.146 3.75214 168.103 3.75214H168.102C167.059 3.75214 166.205 2.90833 166.205 1.87635V1.87597C166.205 0.843999 167.059 0 168.102 0ZM165.08 20.0968C168.015 18.4129 170 15.2709 170 11.6919C170 8.11548 168.018 4.97512 165.087 3.2909L163.302 6.34843C165.166 7.41993 166.426 9.41694 166.426 11.6919C166.426 13.9679 165.164 15.9662 163.298 17.0375L165.08 20.0968Z"
      fill="#DA551B"
    />
  </svg>
);

export const ContentaLogoMobile = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8255 3.47478L13.6423 5.53619C12.5382 4.89807 11.2574 4.53277 9.89123 4.53277C5.7381 4.53277 2.3716 7.90841 2.3716 12.0727C2.3716 16.237 5.7381 19.6129 9.89123 19.6129C11.2574 19.6129 12.5386 19.2477 13.6427 18.6091L14.8255 20.6709C13.3734 21.5104 11.6883 21.9909 9.89123 21.9909C4.42817 21.9909 0 17.5505 0 12.0727C0 6.59487 4.42817 2.15479 9.89123 2.15479C11.6883 2.15479 13.373 2.63523 14.8255 3.47478Z"
      fill="#002842"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8258 20.6709L13.6429 18.6092C15.8954 17.3069 17.4116 14.8672 17.4116 12.0728C17.4116 9.27823 15.8953 6.83898 13.6426 5.53624L14.8258 3.47484C17.7888 5.18794 19.7832 8.39684 19.7832 12.0728C19.7832 15.7487 17.7888 18.9575 14.8258 20.6709ZM18.0869 0C18.9105 0 19.5783 0.669588 19.5783 1.49546C19.5783 2.32124 18.9105 2.99082 18.0869 2.99082C17.2633 2.99082 16.5955 2.32124 16.5955 1.49546C16.5955 0.669588 17.2633 0 18.0869 0Z"
      fill="#DA551B"
    />
  </svg>
);

export const USAFlag = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 3.3C21.65 1.85 18.95 1 16 1V3.3H24Z" fill="#ED4C5C" />
    <path
      d="M16 5.60005H26.8C25.95 4.75005 25 3.95005 24 3.30005H16V5.60005Z"
      fill="white"
    />
    <path
      d="M16 7.89998H28.65C28.1 7.04998 27.5 6.29998 26.85 5.59998H16V7.89998Z"
      fill="#ED4C5C"
    />
    <path
      d="M16 10.2H29.85C29.5 9.40002 29.1 8.60002 28.65 7.90002H16V10.2Z"
      fill="white"
    />
    <path
      d="M16 12.5H30.6C30.4 11.7 30.15 10.95 29.85 10.2H16V12.5Z"
      fill="#ED4C5C"
    />
    <path
      d="M16 14.85H30.95C30.9 14.05 30.75 13.3 30.6 12.55H16V14.85Z"
      fill="white"
    />
    <path
      d="M30.95 14.85H16V16H1C1 16.4 1 16.75 1.05 17.15H30.95C31 16.75 31 16.4 31 16C31 15.6 31 15.2 30.95 14.85Z"
      fill="#ED4C5C"
    />
    <path
      d="M1.3998 19.45H30.5998C30.7998 18.7 30.8998 17.95 30.9498 17.15H1.0498C1.0998 17.9 1.1998 18.7 1.3998 19.45Z"
      fill="white"
    />
    <path
      d="M2.1499 21.75H29.8499C30.1499 21 30.3999 20.25 30.5999 19.45H1.3999C1.5999 20.25 1.8499 21 2.1499 21.75Z"
      fill="#ED4C5C"
    />
    <path
      d="M3.3499 24.05H28.6499C29.0999 23.3 29.4999 22.55 29.8499 21.75H2.1499C2.4999 22.55 2.8999 23.3 3.3499 24.05Z"
      fill="white"
    />
    <path
      d="M5.1501 26.35H26.8501C27.5001 25.65 28.1501 24.85 28.6501 24.05H3.3501C3.8501 24.9 4.5001 25.65 5.1501 26.35Z"
      fill="#ED4C5C"
    />
    <path
      d="M7.9499 28.65H24.0499C25.0999 28 25.9999 27.2 26.8499 26.35H5.1499C5.9999 27.25 6.9499 28 7.9499 28.65Z"
      fill="white"
    />
    <path
      d="M16.0002 31C18.9502 31 21.7002 30.15 24.0502 28.65H7.9502C10.3002 30.15 13.0502 31 16.0002 31Z"
      fill="#ED4C5C"
    />
    <path
      d="M8 3.3C6.95 3.95 6 4.75 5.15 5.6C4.45 6.3 3.85 7.1 3.35 7.9C2.9 8.65 2.45 9.4 2.15 10.2C1.85 10.95 1.6 11.7 1.4 12.5C1.2 13.25 1.1 14 1.05 14.8C1 15.2 1 15.6 1 16H16V1C13.05 1 10.35 1.85 8 3.3Z"
      fill="#428BC1"
    />
    <path
      d="M12.5002 1.5L12.7502 2.25H13.5002L12.9002 2.75L13.1002 3.5L12.5002 3.05L11.9002 3.5L12.1002 2.75L11.5002 2.25H12.2502L12.5002 1.5ZM14.5002 4.5L14.7502 5.25H15.5002L14.9002 5.75L15.1002 6.5L14.5002 6.05L13.9002 6.5L14.1002 5.75L13.5002 5.25H14.2502L14.5002 4.5ZM10.5002 4.5L10.7502 5.25H11.5002L10.9002 5.75L11.1002 6.5L10.5002 6.05L9.9002 6.5L10.1002 5.75L9.5002 5.25H10.2502L10.5002 4.5ZM12.5002 7.5L12.7502 8.25H13.5002L12.9002 8.75L13.1002 9.5L12.5002 9.05L11.9002 9.5L12.1002 8.75L11.5002 8.25H12.2502L12.5002 7.5ZM8.5002 7.5L8.7502 8.25H9.5002L8.9002 8.75L9.1002 9.5L8.5002 9.05L7.9002 9.5L8.1002 8.75L7.5002 8.25H8.2502L8.5002 7.5ZM4.5002 7.5L4.7502 8.25H5.5002L4.9002 8.75L5.1002 9.5L4.5002 9.05L3.9002 9.5L4.1002 8.75L3.5002 8.25H4.2502L4.5002 7.5ZM14.5002 10.5L14.7502 11.25H15.5002L14.9002 11.75L15.1002 12.5L14.5002 12.05L13.9002 12.5L14.1002 11.75L13.5002 11.25H14.2502L14.5002 10.5ZM10.5002 10.5L10.7502 11.25H11.5002L10.9002 11.75L11.1002 12.5L10.5002 12.05L9.9002 12.5L10.1002 11.75L9.5002 11.25H10.2502L10.5002 10.5ZM6.5002 10.5L6.7502 11.25H7.5002L6.9002 11.75L7.10019 12.5L6.5002 12.05L5.9002 12.5L6.10019 11.75L5.5002 11.25H6.2502L6.5002 10.5ZM12.5002 13.5L12.7502 14.25H13.5002L12.9002 14.75L13.1002 15.5L12.5002 15.05L11.9002 15.5L12.1002 14.75L11.5002 14.25H12.2502L12.5002 13.5ZM8.5002 13.5L8.7502 14.25H9.5002L8.9002 14.75L9.1002 15.5L8.5002 15.05L7.9002 15.5L8.1002 14.75L7.5002 14.25H8.2502L8.5002 13.5ZM4.5002 13.5L4.7502 14.25H5.5002L4.9002 14.75L5.1002 15.5L4.5002 15.05L3.9002 15.5L4.1002 14.75L3.5002 14.25H4.2502L4.5002 13.5ZM5.9002 6.5L6.5002 6.05L7.10019 6.5L6.85019 5.75L7.4502 5.25H6.7002L6.5002 4.5L6.2502 5.25H5.5502L6.1502 5.7L5.9002 6.5ZM1.9002 12.5L2.5002 12.05L3.1002 12.5L2.8502 11.75L3.4502 11.25H2.7502L2.5002 10.5L2.2502 11.25H1.7502C1.7502 11.3 1.7002 11.35 1.7002 11.4L2.1002 11.7L1.9002 12.5Z"
      fill="white"
    />
  </svg>
);

export const BrazilFlag = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_37_7770)">
      <path
        d="M19.2188 8.375C18.4688 3.96875 14.625 0.625 10 0.625C5.375 0.625 1.53125 3.96875 0.78125 8.375L10 3.75L19.2188 8.375ZM0.78125 11.625C1.53125 16.0312 5.375 19.375 10 19.375C14.625 19.375 18.4688 16.0312 19.2188 11.625L10 16.25L0.78125 11.625Z"
        fill="#699635"
      />
      <path
        d="M10 3.75L0.78125 8.375C0.6875 8.90625 0.625 9.4375 0.625 10C0.625 10.5625 0.6875 11.0938 0.78125 11.625L10 16.25L19.2188 11.625C19.3125 11.0938 19.375 10.5625 19.375 10C19.375 9.4375 19.3125 8.90625 19.2188 8.375L10 3.75Z"
        fill="#FFE62E"
      />
      <path
        d="M8.125 8.875C7.125 8.875 6.1875 9.09375 5.34375 9.46875C5.3125 9.65625 5.3125 9.8125 5.3125 10C5.3125 12.5938 7.40625 14.6875 10 14.6875C11.75 14.6875 13.2812 13.7188 14.0937 12.3125C12.9375 10.2813 10.6875 8.875 8.125 8.875Z"
        fill="#428BC1"
      />
      <path
        d="M14.625 10.75C14.6562 10.5 14.6875 10.25 14.6875 10C14.6875 7.40625 12.5938 5.3125 10 5.3125C8.15625 5.3125 6.5625 6.375 5.78125 7.9375C6.53125 7.71875 7.3125 7.59375 8.125 7.59375C10.7812 7.59375 13.125 8.84375 14.625 10.75Z"
        fill="#428BC1"
      />
      <path
        d="M8.125 7.59375C7.3125 7.59375 6.53125 7.71875 5.78125 7.9375C5.5625 8.40625 5.40625 8.90625 5.34375 9.46875C6.1875 9.09375 7.125 8.875 8.125 8.875C10.6875 8.875 12.9375 10.25 14.0937 12.2812C14.375 11.8125 14.5312 11.2813 14.625 10.75C13.125 8.84375 10.7812 7.59375 8.125 7.59375Z"
        fill="white"
      />
      <path
        d="M6.875 10.3125C7.04759 10.3125 7.1875 10.1726 7.1875 10C7.1875 9.82741 7.04759 9.6875 6.875 9.6875C6.70241 9.6875 6.5625 9.82741 6.5625 10C6.5625 10.1726 6.70241 10.3125 6.875 10.3125Z"
        fill="white"
      />
      <path
        d="M8.125 12.1875C8.29759 12.1875 8.4375 12.0476 8.4375 11.875C8.4375 11.7024 8.29759 11.5625 8.125 11.5625C7.95241 11.5625 7.8125 11.7024 7.8125 11.875C7.8125 12.0476 7.95241 12.1875 8.125 12.1875Z"
        fill="white"
      />
      <path
        d="M10 12.1875C10.1726 12.1875 10.3125 12.0476 10.3125 11.875C10.3125 11.7024 10.1726 11.5625 10 11.5625C9.82741 11.5625 9.6875 11.7024 9.6875 11.875C9.6875 12.0476 9.82741 12.1875 10 12.1875Z"
        fill="white"
      />
      <path
        d="M10 13.4375C10.1726 13.4375 10.3125 13.2976 10.3125 13.125C10.3125 12.9524 10.1726 12.8125 10 12.8125C9.82741 12.8125 9.6875 12.9524 9.6875 13.125C9.6875 13.2976 9.82741 13.4375 10 13.4375Z"
        fill="white"
      />
      <path
        d="M12.5 12.1875C12.6726 12.1875 12.8125 12.0476 12.8125 11.875C12.8125 11.7024 12.6726 11.5625 12.5 11.5625C12.3274 11.5625 12.1875 11.7024 12.1875 11.875C12.1875 12.0476 12.3274 12.1875 12.5 12.1875Z"
        fill="white"
      />
      <path
        d="M12.5 13.4375C12.6726 13.4375 12.8125 13.2976 12.8125 13.125C12.8125 12.9524 12.6726 12.8125 12.5 12.8125C12.3274 12.8125 12.1875 12.9524 12.1875 13.125C12.1875 13.2976 12.3274 13.4375 12.5 13.4375Z"
        fill="white"
      />
      <path
        d="M11.25 12.8125C11.4226 12.8125 11.5625 12.6726 11.5625 12.5C11.5625 12.3274 11.4226 12.1875 11.25 12.1875C11.0774 12.1875 10.9375 12.3274 10.9375 12.5C10.9375 12.6726 11.0774 12.8125 11.25 12.8125Z"
        fill="white"
      />
      <path
        d="M6.875 11.5625C7.04759 11.5625 7.1875 11.4226 7.1875 11.25C7.1875 11.0774 7.04759 10.9375 6.875 10.9375C6.70241 10.9375 6.5625 11.0774 6.5625 11.25C6.5625 11.4226 6.70241 11.5625 6.875 11.5625Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_37_7770">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UserIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 17.3333C19.1947 17.3333 22.1 18.2586 24.2373 19.5626C25.304 20.2133 26.216 20.9813 26.8747 21.816C27.5227 22.636 28 23.6173 28 24.6666C28 25.7933 27.452 26.6813 26.6627 27.3146C25.916 27.9146 24.9307 28.312 23.884 28.5893C21.78 29.1453 18.972 29.3333 16 29.3333C13.028 29.3333 10.22 29.1466 8.116 28.5893C7.06933 28.312 6.084 27.9146 5.33733 27.3146C4.54667 26.68 4 25.7933 4 24.6666C4 23.6173 4.47733 22.636 5.12533 21.8146C5.784 20.9813 6.69467 20.2146 7.76267 19.5613C9.9 18.26 12.8067 17.3333 16 17.3333ZM16 20C13.3027 20 10.876 20.7866 9.152 21.8386C8.28933 22.364 7.63867 22.9346 7.21867 23.468C6.78667 24.0146 6.66667 24.428 6.66667 24.6666C6.66667 24.8293 6.716 25.0013 7.00667 25.2346C7.33867 25.5013 7.916 25.7773 8.79867 26.0106C10.556 26.4773 13.0813 26.6666 16 26.6666C18.92 26.6666 21.444 26.476 23.2 26.0106C24.084 25.7773 24.6613 25.5013 24.9933 25.2346C25.284 25.0013 25.3333 24.8293 25.3333 24.6666C25.3333 24.4266 25.2133 24.0146 24.7827 23.468C24.3613 22.9346 23.7107 22.364 22.848 21.8386C21.124 20.7853 18.6973 20 16 20ZM16 2.66663C17.7681 2.66663 19.4638 3.369 20.714 4.61925C21.9643 5.86949 22.6667 7.56518 22.6667 9.33329C22.6667 11.1014 21.9643 12.7971 20.714 14.0473C19.4638 15.2976 17.7681 16 16 16C14.2319 16 12.5362 15.2976 11.286 14.0473C10.0357 12.7971 9.33333 11.1014 9.33333 9.33329C9.33333 7.56518 10.0357 5.86949 11.286 4.61925C12.5362 3.369 14.2319 2.66663 16 2.66663ZM16 5.33329C15.4747 5.33329 14.9546 5.43676 14.4693 5.63777C13.984 5.83879 13.543 6.13343 13.1716 6.50487C12.8001 6.8763 12.5055 7.31726 12.3045 7.80256C12.1035 8.28786 12 8.808 12 9.33329C12 9.85858 12.1035 10.3787 12.3045 10.864C12.5055 11.3493 12.8001 11.7903 13.1716 12.1617C13.543 12.5332 13.984 12.8278 14.4693 13.0288C14.9546 13.2298 15.4747 13.3333 16 13.3333C17.0609 13.3333 18.0783 12.9119 18.8284 12.1617C19.5786 11.4116 20 10.3942 20 9.33329C20 8.27243 19.5786 7.25501 18.8284 6.50487C18.0783 5.75472 17.0609 5.33329 16 5.33329Z"
      fill="#6D6D6D"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 9.5H26.5M5.5 16H26.5M5.5 22.5H26.5"
      stroke="#6D6D6D"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const TravelExpertIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8004 9.8C13.6782 9.8 15.2004 8.27777 15.2004 6.4C15.2004 4.52223 13.6782 3 11.8004 3C9.92262 3 8.40039 4.52223 8.40039 6.4C8.40039 8.27777 9.92262 9.8 11.8004 9.8Z"
      fill="#003B5B"
    />
    <path
      d="M18.6 16.1751C18.6 18.2873 18.6 20.0001 11.8 20.0001C5 20.0001 5 18.2873 5 16.1751C5 14.0628 8.0447 12.3501 11.8 12.3501C15.5553 12.3501 18.6 14.0628 18.6 16.1751Z"
      fill="#003B5B"
    />
  </svg>
);

export const TravelerIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.904 6.99988H13.096V4.80788H10.904V6.99988ZM12 12.3849C10.926 12.3849 9.88733 12.1992 8.884 11.8279C7.882 11.4566 6.92067 10.9846 6 10.4119V8.61488C6 8.17088 6.158 7.79088 6.474 7.47488C6.79 7.15888 7.17067 7.00055 7.616 6.99988H9.904V4.57688C9.904 4.37022 9.98067 4.19022 10.134 4.03689C10.2873 3.88355 10.467 3.80688 10.673 3.80688H13.327C13.5337 3.80688 13.7137 3.88355 13.867 4.03689C14.0203 4.19022 14.097 4.37022 14.097 4.57688V6.99988H16.385C16.829 6.99988 17.209 7.15822 17.525 7.47488C17.841 7.79155 17.9993 8.17155 18 8.61488V10.4119C17.08 10.9852 16.1187 11.4572 15.116 11.8279C14.1133 12.1992 13.0747 12.3849 12 12.3849ZM7.616 20.9999V19.9999C7.17133 19.9999 6.791 19.8416 6.475 19.5249C6.159 19.2082 6.00067 18.8286 6 18.3859V11.5859C6.85667 12.0752 7.74233 12.4786 8.657 12.7959C9.57167 13.1119 10.5193 13.3046 11.5 13.3739V14.3849H12.5V13.3739C13.4807 13.3046 14.4283 13.1116 15.343 12.7949C16.2583 12.4782 17.144 12.0749 18 11.5849V18.3849C18 18.8296 17.8417 19.2099 17.525 19.5259C17.2083 19.8419 16.8283 20.0002 16.385 20.0009V21.0009H15.385V20.0009H8.615V21.0009L7.616 20.9999Z"
      fill="#003B5B"
    />
  </svg>
);

export const TravelAgencyIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.4 4H17.6L19 8.4A2.33 2.33 0 0 1 14.33 8.4A2.33 2.33 0 0 1 9.67 8.4A2.33 2.33 0 0 1 5 8.4L6.4 4Z"
      fill="#003B5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11.4H18V19C18 19.55 17.55 20 17 20H13.6V15.6H10.4V20H7C6.45 20 6 19.55 6 19V11.4Z"
      fill="#003B5B"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_362_63669)">
      <path
        d="M10.24 0C13.385 0 16.297 1.395 18.228 3.744C18.283 3.81059 18.3241 3.88756 18.3487 3.97033C18.3734 4.05311 18.3811 4.14 18.3715 4.22583C18.3619 4.31167 18.3351 4.39469 18.2928 4.46997C18.2504 4.54524 18.1934 4.61123 18.125 4.664C17.9858 4.7731 17.8096 4.82368 17.6337 4.80501C17.4579 4.78634 17.2962 4.69989 17.183 4.564C16.3387 3.54117 15.2778 2.71854 14.077 2.15547C12.8761 1.59241 11.5653 1.30295 10.239 1.308C5.324 1.308 1.339 5.2 1.339 10C1.339 14.8 5.324 18.692 10.239 18.692C11.5844 18.6973 12.9137 18.3995 14.1283 17.8208C15.3429 17.2421 16.4116 16.3972 17.255 15.349C17.3663 15.2117 17.5266 15.1231 17.7021 15.102C17.8776 15.0809 18.0544 15.129 18.195 15.236C18.264 15.2879 18.3218 15.3531 18.3651 15.4277C18.4084 15.5024 18.4362 15.585 18.4469 15.6706C18.4577 15.7563 18.4511 15.8432 18.4275 15.9262C18.404 16.0093 18.364 16.0867 18.31 16.154C16.382 18.564 13.431 20 10.24 20C4.583 20 0 15.523 0 10C0 4.477 4.584 0 10.24 0ZM17.098 7.16L19.804 9.867C20.066 10.128 20.071 10.547 19.816 10.803L17.172 13.446C17.11 13.507 17.0366 13.5552 16.9559 13.5877C16.8752 13.6203 16.7889 13.6366 16.7019 13.6356C16.6149 13.6347 16.529 13.6166 16.449 13.5823C16.3691 13.5481 16.2967 13.4983 16.236 13.436C16.1734 13.3754 16.1235 13.303 16.0891 13.223C16.0546 13.1429 16.0364 13.0569 16.0354 12.9698C16.0343 12.8827 16.0506 12.7962 16.0831 12.7154C16.1157 12.6346 16.1639 12.5611 16.225 12.499L17.772 10.952H7.462C7.37499 10.9533 7.28858 10.9374 7.20774 10.9052C7.1269 10.873 7.05323 10.8252 6.99096 10.7644C6.92869 10.7036 6.87905 10.6311 6.84491 10.5511C6.81076 10.471 6.79278 10.385 6.792 10.298C6.792 9.936 7.092 9.643 7.462 9.643H17.731L16.173 8.085C16.1106 8.02439 16.0608 7.95205 16.0264 7.87212C15.9921 7.7922 15.9739 7.70627 15.9729 7.61929C15.9718 7.5323 15.988 7.44597 16.0205 7.36526C16.0529 7.28455 16.101 7.21106 16.162 7.149C16.2241 7.08804 16.2976 7.03994 16.3783 7.00748C16.459 6.97502 16.5453 6.95884 16.6323 6.95986C16.7193 6.96088 16.8052 6.97909 16.8851 7.01344C16.965 7.04778 17.0374 7.09759 17.098 7.16Z"
        fill="#FE432A"
      />
    </g>
    <defs>
      <clipPath id="clip0_362_63669">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
